import {createSelector} from 'reselect';

const selectPushNotification = (state) => state.pushNotification;

const selectPushNotificationIsSubscribing = createSelector(
    selectPushNotification,
    (pushNotificationState) => pushNotificationState.isSubscribing
);

const selectPushNotificationIsUnsubscribing = createSelector(
    selectPushNotification,
    (pushNotificationState) => pushNotificationState.isUnsubscribing
);

const selectPushNotificationIsStoringToBackend = createSelector(
    selectPushNotification,
    (pushNotificationState) => pushNotificationState.isStoringToBackend
);

const selectPushNotificationIsDeletingFromBackend = createSelector(
    selectPushNotification,
    (pushNotificationState) => pushNotificationState.isDeletingFromBackend
);

const selectPushNotificationSubscription = createSelector(
    selectPushNotification,
    (pushNotificationState) => pushNotificationState.subscription
);

const selectPushNotificationIsSettingChangeInProgress = createSelector(
    selectPushNotification,
    (pushNotificationState) => pushNotificationState.isUpdatingSettings
);

const selectPushNotificationIsAnyOperationInProgress = createSelector(
    selectPushNotification,
    (pushNotificationState) =>
        pushNotificationState.isSubscribing ||
        pushNotificationState.isUnsubscribing ||
        pushNotificationState.isStoringToBackend ||
        pushNotificationState.isDeletingFromBackend
);

export {
    selectPushNotificationIsAnyOperationInProgress,
    // TODO: remove if is not needed
    selectPushNotificationIsDeletingFromBackend,
    selectPushNotificationIsSettingChangeInProgress,
    selectPushNotificationIsStoringToBackend,
    selectPushNotificationIsSubscribing,
    selectPushNotificationIsUnsubscribing,
    selectPushNotificationSubscription,
};
